import { render, staticRenderFns } from "./Coc.vue?vue&type=template&id=01df3d49&"
import script from "./Coc.vue?vue&type=script&lang=js&"
export * from "./Coc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports